import React from 'react';

const CiatAppContext = React.createContext({});

export default CiatAppContext;
